import Forward from "@mui/icons-material/Forward";

import { makeSvgIcon } from "./svg-icon";

export const ForwardIcon = makeSvgIcon(Forward);

export default ForwardIcon;
